import React from 'react';

import LayoutContext from './LayoutContext';

const withLayout = WrappedComponent => {
  return props => (
    <LayoutContext.Consumer>
      {layout => <WrappedComponent layout={layout} {...props} />}
    </LayoutContext.Consumer>
  );
};

export default withLayout;
